import React from 'react'

import { Box } from '~/components/elements/Box'
import { Suspense } from '~/components/elements/Suspense'
import { ZStack } from '~/components/elements/ZStack'
import { type CustomerStrategySegmentRoute } from '~/gql/graphql'
import { useLogEvent } from '~/hooks/useLogEvent'
import { nineNumbers } from '~/utils'

import { useIsTabulationFetching } from '../../hooks/useTabulationQuery'

import { Arrows, nineSegmentArrowRoutes } from './Arrows'
import { NineNumberCell } from './NineNumberCell'
import styles from './NineSegmentPanel.css'

export { nineSegmentArrowRoutes }

export type NineSegmentPanelProps = {
  selectedRoute: CustomerStrategySegmentRoute | null
  onRouteChange: (route: CustomerStrategySegmentRoute | null) => void
}

export const NineSegmentPanel = React.forwardRef<
  HTMLDivElement,
  NineSegmentPanelProps
>(({ onRouteChange, selectedRoute }, ref) => {
  const isTabulationFetching = useIsTabulationFetching()

  const logEvent = useLogEvent()
  const handleRouteChange = (route: CustomerStrategySegmentRoute | null) => {
    onRouteChange(route)
    logEvent('Select growth route', { withSuffix: true })
  }

  return (
    <ZStack ref={ref} className={styles.root}>
      <Suspense loading={isTabulationFetching} loadingContainerSize="mini">
        <Box className={styles.panel}>
          {nineNumbers.map((nineNumber) => (
            <NineNumberCell
              key={nineNumber}
              nineNumber={nineNumber}
              selectedRoute={selectedRoute}
            />
          ))}
        </Box>

        <Arrows
          selectedRoute={selectedRoute}
          onRouteChange={handleRouteChange}
        />
      </Suspense>
    </ZStack>
  )
})
